import React from 'react';
import { ReactComponent as Success } from '../../assets/images/success.svg';

function SuccessPopup(props) {
  const {
    displayText = 'Title', description = 'This is Discreption', okayText = 'Close', cancelText = 'Cancel Button', onOkay, onCancel, show, showOkayButton, showCancelButton,
  } = props;

  return (
    show
    && (
      <>
        <div className="overlay" />
        <div className="Team-PopUp-Container-Common">
          <div className="Successful-Container">
            <Success />
          </div>
          <div className="Success_static_container">
            <p className="Succes_static_text">{displayText}</p>
            <p className="Succes_static_discreption">{description}</p>
          </div>
          <div className="chatLimit-button">
            {showCancelButton
            && (
              <button className="SendChat-Button" type="button" onClick={onCancel}>
                {cancelText}
              </button>
            )}
            {showOkayButton
            && (
              <button className="SendChat-Button01" type="button" onClick={onOkay}>
                {okayText}
              </button>
            )}
          </div>
        </div>
      </>
    )
  );
}

export default SuccessPopup;
